import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import env from '../misc/env';
import { extractMessageFromError } from '../utils/errorUtil';
import { Store } from 'libx';
import { DraftApi } from './API';
import Quote from './Quote';
import { delay } from 'fejl';
import { StatusCode } from 'grpc-web';
import * as ProvidersMapper from './mappers/ProvidersMapper';
var DraftStore = /*#__PURE__*/function (_Store) {
  function DraftStore() {
    var _this;
    _classCallCheck(this, DraftStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DraftStore, [].concat(args));
    _this.api = new DraftApi({
      baseURL: env.WORK_DOTNET_API,
      token$: _this.rootStore.authStore.token$
    }, _this.rootStore.workRealtime$);
    _this.quotes = _this.collection({
      model: Quote
    });
    return _this;
  }
  _inherits(DraftStore, _Store);
  return _createClass(DraftStore, [{
    key: "replaceQuestionAnswers",
    value: (
    /**
     * Replace draft question answers.
     *
     * @param {string} draftId.
     * @param {Object[]} questions. Replaces all question answers belonging to this
     * draft. Any question not included but which had been previously answered will
     * have its answer value removed.
     * @param {string} questions[].id The unique question identifier.
     * @param {string} questions[].type The question type.
     * @param {string} questions[].multi Determines if the select question type allows
     * for multiple choices.
     * @param {any} questions[].answer Its value will depend upon the question's type.
     */
    function () {
      var _replaceQuestionAnswers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(draftId, questions) {
        var _this2 = this;
        var payload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = questions.filter(function (question) {
                return question.isAnswered;
              });
              _context.next = 3;
              return this.api.replaceQuestionAnswers(draftId, payload).catch(function (e) {
                _this2.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function replaceQuestionAnswers(_x, _x2) {
        return _replaceQuestionAnswers.apply(this, arguments);
      }
      return replaceQuestionAnswers;
    }()
    /**
     * @param {string} id - Id of the job
     * @param {string?} billingMethodId - (optional) The id of the billing method in which to charge
     * @param {string?} bypassBilling - (optional) Default to false, and if true, disables billing for the job
     */
    )
  }, {
    key: "submitDraft",
    value: (function () {
      var _submitDraft = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, billingMethodId) {
        var bypassBilling,
          response,
          _jobSubmissionProgres,
          _jobSubmissionProgres2,
          jobSubmissionProgress,
          failed,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              bypassBilling = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              _context2.next = 3;
              return this.api.submitDraftJob(id, billingMethodId, bypassBilling);
            case 3:
              response = _context2.sent;
            case 4:
              _context2.next = 6;
              return delay(400);
            case 6:
              _context2.prev = 6;
              _context2.next = 9;
              return this.api.getJobSubmissionProgress(response.getSubmissionId());
            case 9:
              jobSubmissionProgress = _context2.sent;
              if (!((_jobSubmissionProgres = jobSubmissionProgress.getStatus()) !== null && _jobSubmissionProgres !== void 0 && _jobSubmissionProgres.getCompleted())) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return");
            case 12:
              failed = (_jobSubmissionProgres2 = jobSubmissionProgress.getStatus()) === null || _jobSubmissionProgres2 === void 0 ? void 0 : _jobSubmissionProgres2.getFailed();
              if (!failed) {
                _context2.next = 15;
                break;
              }
              throw new Error(failed.getDescription());
            case 15:
              _context2.next = 21;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](6);
              if (!(_context2.t0.code !== StatusCode.NOT_FOUND)) {
                _context2.next = 21;
                break;
              }
              throw _context2.t0;
            case 21:
              if (true) {
                _context2.next = 4;
                break;
              }
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[6, 17]]);
      }));
      function submitDraft(_x3, _x4) {
        return _submitDraft.apply(this, arguments);
      }
      return submitDraft;
    }()
    /**
     * Create a draft job.
     *
     * @param {string} legendId The unique legend identifier.
     * @param {number} legendVersion The legend version.
     * @param {string} clientUserPublicId If not null, then this member will be assign as the job's owner.
     * @returns {Promise<string>}  The jobId.
     */
    )
  }, {
    key: "createDraftJob",
    value: (function () {
      var _createDraftJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(legendId, legendVersion, clientUserPublicId) {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.createDraftJob(legendId, legendVersion, clientUserPublicId).catch(function (e) {
                _this3.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createDraftJob(_x5, _x6, _x7) {
        return _createDraftJob.apply(this, arguments);
      }
      return createDraftJob;
    }()
    /**
     * Create a draft job for a team.
     *
     * @param {string} legendId The unique legend identifier.
     * @param {number} legendVersion The legend version.
     * @param {string} teamId The team that the user belongs to.
     * @param {string} clientUserPublicId If not null, then this team member will be assign as the job's owner.
     * @returns {Promise<string>}  The jobId.
     */
    )
  }, {
    key: "createTeamDraftJob",
    value: (function () {
      var _createTeamDraftJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(legendId, legendVersion, teamId, clientUserPublicId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.api.createTeamDraftJob(legendId, legendVersion, teamId, clientUserPublicId));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createTeamDraftJob(_x8, _x9, _x10, _x11) {
        return _createTeamDraftJob.apply(this, arguments);
      }
      return createTeamDraftJob;
    }()
    /* Requests a champion provider for a draft.
     *
     * @param {string} draftId.
     * @param {(string|null)} championProviderId. When null, any champion provider that
     * can be assigned to this job will be requested.
     */
    )
  }, {
    key: "requestChampionProvider",
    value: (function () {
      var _requestChampionProvider = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(draftId, championProviderId) {
        var _this4 = this;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.api.requestChampionProvider(draftId, championProviderId).catch(function (e) {
                _this4.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function requestChampionProvider(_x12, _x13) {
        return _requestChampionProvider.apply(this, arguments);
      }
      return requestChampionProvider;
    }()
    /**
     * Get quote for a draft.
     */
    )
  }, {
    key: "getQuote",
    value: (function () {
      var _getQuote = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(draftId) {
        var _this5 = this;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.api.getQuote(draftId).then(this.quotes.set).catch(function (e) {
                _this5.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              }));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getQuote(_x14) {
        return _getQuote.apply(this, arguments);
      }
      return getQuote;
    }()
    /* Archives draft.
     *
     * @param {string} draftId.
     */
    )
  }, {
    key: "archive",
    value: (function () {
      var _archive = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(draftId) {
        var _this6 = this;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.api.archive(draftId).catch(function (e) {
                _this6.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function archive(_x15) {
        return _archive.apply(this, arguments);
      }
      return archive;
    }()
    /* Applies coupon to draft.
     *
     * @param {string} draftId.
     * @param {string} couponId.
     */
    )
  }, {
    key: "applyCoupon",
    value: (function () {
      var _applyCoupon = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(draftId, couponId) {
        var _this7 = this;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.api.applyCoupon(draftId, couponId).catch(function (e) {
                _this7.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function applyCoupon(_x16, _x17) {
        return _applyCoupon.apply(this, arguments);
      }
      return applyCoupon;
    }()
    /* Removes coupon from draft.
     *
     * @param {string} draftId.
     */
    )
  }, {
    key: "removeCoupon",
    value: (function () {
      var _removeCoupon = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(draftId) {
        var _this8 = this;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.api.removeCoupon(draftId).catch(function (e) {
                _this8.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function removeCoupon(_x18) {
        return _removeCoupon.apply(this, arguments);
      }
      return removeCoupon;
    }()
    /* Upgrade legend.
     *
     * @param {string} draftId.
     */
    )
  }, {
    key: "upgradeLegend",
    value: (function () {
      var _upgradeLegend = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(draftId) {
        var _this9 = this;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.api.upgradeLegend(draftId).catch(function (e) {
                _this9.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function upgradeLegend(_x19) {
        return _upgradeLegend.apply(this, arguments);
      }
      return upgradeLegend;
    }()
    /**
     * Lists previous providers for a given user and workspace.
     *
     * @param {string} workspaceId - The workspace ID.
     * @param {string} userPublicId - The user public ID.
     * @returns {Promise<Provider[]>}
     */
    )
  }, {
    key: "listPreviousProviders",
    value: (function () {
      var _listPreviousProviders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(workspaceId, userPublicId) {
        var _this10 = this;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.api.listPreviousProviders(workspaceId, userPublicId).then(function (res) {
                return res.previousProvidersList;
              }).then(function (providers) {
                return providers.map(ProvidersMapper.fromDto);
              }).catch(function (e) {
                _this10.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              }));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function listPreviousProviders(_x20, _x21) {
        return _listPreviousProviders.apply(this, arguments);
      }
      return listPreviousProviders;
    }()
    /**
     * Fetches matching providers count.
     *
     * @param {string} id - The job ID.
     * @returns {Promise<{count: number}>}
     */
    )
  }, {
    key: "getMatchingProvidersCount",
    value: (function () {
      var _getMatchingProvidersCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id) {
        var _this11 = this;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.api.getMatchingProvidersCount(id).then(function (res) {
                return {
                  count: res.matchingProvidersCount
                };
              }).catch(function (e) {
                _this11.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              }));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getMatchingProvidersCount(_x22) {
        return _getMatchingProvidersCount.apply(this, arguments);
      }
      return getMatchingProvidersCount;
    }())
  }]);
}(Store);
export { DraftStore as default };
//# sourceMappingURL=DraftStore.js.map
